import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { UtilityService } from '@services/utility.service';
import { SiteCookies } from '@constants/global';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {

  constructor(private utility: UtilityService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if(!request.url.includes('login') && 
    !request.url.includes('fetch-site-data') && 
    !request.url.includes('get-new-token')){

      const modified = request.clone({
        setHeaders: {
          "Authorization": 'Bearer ' + this.utility.getCookie(SiteCookies.ACCESSTOKEN)
        }
      });
      
      return next.handle(modified);
    }
    return next.handle(request);
  }
}
